export const allFeelings = [
  {
    id: 1,
    name: 'Optimistic',
    color: '#3e93a7',
  },
  {
    id: 2,
    name: 'Good',
    color: '#4aa9bf',
  },
  {
    id: 3,
    name: 'Ok',
    color: 'rgb(155 218 233)',
  },
  {
    id: 4,
    name: 'Frustrated',
    color: '#f8bb1f',
  },
  {
    id: 5,
    name: 'Worried',
    color: '#ef7d2f',
  },
  {
    id: 6,
    name: 'Stressed',
    color: '#ea666b',
  },
  {
    id: 7,
    name: 'Burnt out',
    color: '#e9555f',
  },
];
